import React from 'react';
import './index.css';
import IntakeWizard from './components/IntakeWizard';

function App() {
  return (
    <div className="app">
      <IntakeWizard />
    </div>
  );
}

export default App;
